import { useMemo } from 'react';
import { createEditor } from './createEditor.mjs';

function useEditor(args, dependencies = []) {
  return useMemo(() => createEditor(args),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  dependencies);
}

export { useEditor };
